import axios from 'axios'
import { Store } from './LocalCache.js'

export const baseURL = "/api"
const instance = axios.create({
    baseURL: baseURL,
    // timeout: 60000,
    headers: {}
});

instance.interceptors.request.use((request) => {

    const accessToken = Store.get("access_token")
    const headerToken = request.headers.Authorization
    if (!headerToken && accessToken) {
        request.headers.Authorization = `Bearer ${accessToken}`
    }
    
    //header 编码处理
    const contentType = request.headers['Content-Type'] || "application/json"
    const body = request.body
    if (contentType.indexOf('x-www-form-urlencoded') > -1) {
        //修改编码方式
        request.body = Object.keys(body).map(key => `${key}=${body[key]}`).join("&")
    }
    return request;
}, function(error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function(response) {
    if (response.headers["x-set-jwt"]) {
        Store.put('access_token', response.headers["x-set-jwt"])
    }
    const data = response.data
    if (response.data.code == 401) {
        //重新登录
        Store.del("access_token")
        window.location.reload()
    }
    return data;
}, function(error) {
    const response = error.response

    if (response) {
        const status = response.status

        if (status == 401 || status == 403) {
            //重新登录
            Store.del("access_token")
            window.location.reload()
        }
    }

    return Promise.reject(response ? response.data : error);
});

export function get(url, query, config) {
    return instance.get(url, {
        params: query
    }, config)
}

export function post(url, data, config) {
    return instance.post(url, data, config)
}

export function del(url, data, config) {
    return instance.delete(url, data, config)
}

export function put(url, data, config) {
    return instance.put(url, data, config)
}